module.exports = __webpack_public_path__ + "img/RozaShekhani-TrsLaFeminism.d77357d0.jpg";